import(/* webpackMode: "eager" */ './homepage-hero.scss')
import { Loader } from '@googlemaps/js-api-loader'

const widget = $('.widget.homepage-hero')
const stillLoadingTimeout = setTimeout(function () {
  widget.addClass('still-loading')
}, 250)

;(async () => {
  const { default: moment } = await import('moment')
  await import('../../plugins/semantic/form')
  await Promise.all([
    import('../../scripts/dbs/dbs.semantic.form'),
    import('../../plugins/semantic/table.css'),
    import('../../plugins/semantic/popup.css'),
    import('../../plugins/semantic/icon.css'),
    import('../../plugins/semantic/popup'),
    import('../../plugins/semantic/modal.scss'),
    import('../../plugins/semantic/modal'),
    import('../../plugins/semantic/dimmer.scss'),
    import('../../plugins/semantic/dimmer'),
    import('../../plugins/semantic-calendar/calendar'),
    import('../../plugins/semantic-calendar/calendar.css'),
    import('../../plugins/semantic/search'),
    import('../../plugins/semantic/search.scss'),
    import('../../plugins/semantic/api'),
    import('../../plugins/semantic/transition.css'),
    import('../../plugins/semantic/transition'),
    import('../guest-selector/guest-selector'),
    import('../guest-selector/guest-selector.scss'),
    import('../location-typeahead/location-typeahead.scss'),
  ])

  widget.data('widget', new HomepageHero(widget, moment))
  widget.data('widget').init()
})()

function HomepageHero(el, moment) {
  const self = this
  self.el = $(el)

   
  const todayDate = new Date()
  var tomorrowDate = moment().add(1, 'days').toDate()
  const maxDate = new moment().add(1, 'years').toDate()
  let isMobile = $('body').hasClass('is-mobile-view');

  const noLocationError = self.el.find('.location-error')

  function showNoLocationSelectedError() {
    noLocationError.css('display', 'inline-block')
  }

  function hideNoLocationSelectedError() {
    noLocationError.css('display', 'none')
  }

  function showGeoLocationUnavailableError() {
    $('.geolocation-popup').modal({ closable: true }).modal('show')
  }

  function handleGeoLocationPositionResponse(response) {
    const redirectUrl = self.el.find('.current-location').attr('data-redirect')

    let filters = {
      lat: response.coords.latitude,
      lng: response.coords.longitude,
      //hideDistance: 'false', // string: ['true'|'false'|'mapMove']. Default = 'mapMove'.
      arrive: moment(self.el.find('.arrive-field input').val(), 'DD/MM/YYYY').format('YYYY-MM-DD'),
      depart: moment(self.el.find('.depart-field input').val(), 'DD/MM/YYYY').format('YYYY-MM-DD'),
      adults: self.el.find('.adults.input').val(),
      kids: self.el.find('.kids.input').val(),
      infants: self.el.find('.infants.input').val(),
      guests: self.el.find('.guests.input').val(),
      zoom: 8,
      isGeoLocationSearch: true,

    }

    let invalidArrive = false
    if (filters.arrive.toLowerCase() === 'invalid date') {
      invalidArrive = true
      filters.arrive = moment(todayDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    if (filters.depart.toLowerCase() === 'invalid date') {
      if (!invalidArrive) {
        filters.depart = moment(self.el.find('.arrive-field input').val(), 'DD/MM/YYYY')
          .add(1, 'd')
          .format('YYYY-MM-DD')
      } else {
        filters.depart = moment(tomorrowDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
    }

    window.location.href = redirectUrl + '?' + $.param(filters)
  }

  function handleSubmitButtonClick(e) {
    e.preventDefault()

    const selectedLocation = self.typeahead.selectedItem
    const arriveDate = moment(self.el.find('.arrive-field input').val(), 'DD/MM/YYYY')
    const departDate = moment(self.el.find('.depart-field input').val(), 'DD/MM/YYYY')

    if (selectedLocation.isPark) {
      const filters = {
        adults: self.el.find('.adults.input').val(),
        kids: self.el.find('.kids.input').val(),
        infants: self.el.find('.infants.input').val(),
        guests: self.el.find('.guests.input').val(),
      }

      if (!isNaN(arriveDate)) {
        filters.arrive = arriveDate.format('YYYY-MM-DD')
      }

      if (!isNaN(departDate)) {
        filters.depart = departDate.format('YYYY-MM-DD')
      }

      window.location.href = selectedLocation.url + '?' + $.param(filters)
      return
    }

    if (selectedLocation.isLocation) {
      let dateToday = new Date()
      dateToday.setHours(0, 0, 0)

      let defaultArrivalDate = new Date()
      defaultArrivalDate.setHours(0, 0, 0)
      defaultArrivalDate.setDate(dateToday.getDate() + 1)

      let defaultDepartureDate = new Date()
      defaultDepartureDate.setHours(0, 0, 0)
      defaultDepartureDate.setDate(dateToday.getDate() + 2)

      self.typeahead.dbsPlacesService.getDetails(
        {
          placeId: selectedLocation.id,
          fields: ['geometry'],
        },
        function (place) {
          let filters = {
            placeId: selectedLocation.id,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            query: selectedLocation.label,
            adults: self.el.find('.adults.input').val(),
            kids: self.el.find('.kids.input').val(),
            infants: self.el.find('.infants.input').val(),
            guests: self.el.find('.guests.input').val(),
            zoom: 8, // TODO Make this a big smarter
          }

          if (!isNaN(arriveDate)) {
            filters.arrive = arriveDate.format('YYYY-MM-DD')
          }

          if (!isNaN(departDate)) {
            filters.depart = departDate.format('YYYY-MM-DD')
          }

          const url = self.el.find('.search-form').attr('data-location')
          window.location.href = url + '?' + $.param(filters)
        },
      )
      return
    }

    return showNoLocationSelectedError()
  }

  const video = self.el.find('video').get(0)
  function handleVideoPauseClick(e) {
    e.preventDefault()
    let pauseButton = $(this)
    pauseButton.toggleClass('paused')
    pauseButton.hasClass('paused') ? video.pause() : video.play()
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('HomepageHero init', self)
    }

    const googleMapsApi = new Loader({
      apiKey: GOOGLE_MAPS_API_KEY,
      version: '3.exp',
      libraries: ['places'],
    })

    googleMapsApi.load().then(async (google) => {
      const { default: typeahead } = await import('../location-typeahead/location-typeahead')

      const searchFormContainerOverlay = self.el.find('.loading-overlay')
      searchFormContainerOverlay[0].onanimationend = () => searchFormContainerOverlay.remove()

      clearTimeout(stillLoadingTimeout)

      self.el.removeClass('loading still-loading')

      self.typeahead = new typeahead(self.el.find('.location-typeahead'), google)

      self.typeahead.init()

      self.typeahead.events.subscribe('LocationTypeahead: selected', hideNoLocationSelectedError)

      self.typeahead.events.subscribe('LocationTypeahead: response', hideNoLocationSelectedError)

      self.typeahead.geolocation.events.subscribe('Geolocation:getPosition_error', showGeoLocationUnavailableError)

      self.typeahead.geolocation.events.subscribe('Geolocation:getPosition_response', handleGeoLocationPositionResponse)
    })

    self.el.find('.arrow').click(function (e) {
      e.preventDefault()
      $('html, body').animate({ scrollTop: self.el.outerHeight() }, 500)
    })

    self.el.find('.pause').click(handleVideoPauseClick)
    
    self.el.find('.arrive-calendar').calendar({
      type: 'date',
      minDate: todayDate,
      maxDate: maxDate,
      endCalendar: $('.depart-calendar'),
      startCalendar: $('.arrive-calendar'),
      popupOptions: {
        position: 'bottom left',
        lastResort: 'bottom left',
        prefer: 'opposite',
        hideOnScroll: false,
        touchReadonly: false
      },
      formatter: {
        date: (date) => moment(date).format('DD/MM/YYYY').toString(),
      },
      parser: {
        date: (text) => moment(text, 'DD/MM/YYYY').toDate(),
      },
      onVisible() {
        if (isMobile) {  
          setTimeout(function () { $('.ui.search').removeClass('focus') }, 250)
          $('#location-typeahead').trigger('blur')
        }
      },
      
      onChange(date, text, mode)
      {
        tomorrowDate = moment(date).add(1, 'days').toDate();
        self.el.find('.depart-calendar').calendar('setting', 'minDate', tomorrowDate);
      }
    })

    self.el.find('.depart-calendar').calendar({
      type: 'date',
      startCalendar: $('.arrive-calendar'),
      minDate: tomorrowDate,
      maxDate: maxDate,
      popupOptions: {
        position: 'bottom right',
        lastResort: 'bottom right',
        prefer: 'opposite',
        hideOnScroll: false,
      },
      formatter: {
        date: (date) => moment(date).format('DD/MM/YYYY').toString(),
      },
      parser: {
        date: (text) => moment(text, 'DD/MM/YYYY').toDate(),
      },
      // eslint-disable-next-line no-unused-vars
      onChange(date, text, mode) {
        const arriveDate = moment($('.arrive-calendar input').val());
        const departDate = moment(date).toDate();

        if (arriveDate.isSame(departDate))
        {
          const arrivalDateNextDay = moment(arriveDate, 'DD/MM/YYYY').add(1, 'd').toDate()
          self.el.find('.depart-calendar').calendar('set date', arrivalDateNextDay, true, true)
          self.el.find('.depart-calendar').click()

          return false
        }

        return true
      },
    })

    self.el.find('.submit.button').click(handleSubmitButtonClick)
  }
}
